module.exports = "<span ng-transclude></span>"